import { LinkField } from "../../linkField"

export const Buttons = ({ buttons }) => {
  return (
    <div className="flex justify-center">
      {buttons.map((item) => (
        <LinkField
          key={item.uid}
          className={`${
            item.style === "outline"
              ? "text-pink border-pink hover:text-white border-2"
              : "text-white bg-pink"
            } inline-block px-4 mx-2 py-3 xl:px-10 xl:py-4 xl:mx-4 font-normal text-center  rounded hover:bg-btnhover`}
          {...item.btnLink}
        />
      ))}
    </div>
  )
}
